<template>
  <v-container fluid>
    <v-layout>
      <v-flex>
        <h1 class="headline mt-2">Funnel View</h1>
      </v-flex>
      <v-flex class="text-xs-right">
        <span>
          <v-btn @click="exportData" outline color="grey" class="ma-0 mb-1">
            <i class="fas fa-file-export mr-1"></i>
            {{$t('export')}}
          </v-btn>
        </span>
        <v-btn
          outline
          color="primary"
          @click="showSearch = true"
          :loading="loading"
        >Filter/Search by Date</v-btn>

        <v-dialog v-model="showSearch" persistent max-width="600" scrollable>
          <v-card>
            <div class="text-xs-right">
              <v-btn small flat fab @click="showSearch = false" :loading="loading">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <v-card-text max-height="600">
              <v-layout wrap>
                <v-flex xs12 sm6 class="px-1">
                  <div class="caption">Group</div>
                  <multiselect
                    class="mb-3"
                    v-model="filter.group"
                    :options="agentGroupOptions"
                    label="groupname"
                    selectLabel
                    selectedLabel
                    :allow-empty="false"
                    :searchable="false"
                    deselect-label
                    @input="onChangeGroup"
                    track-by="groupname"
                  ></multiselect>
                </v-flex>
                <template v-if="filter.group && filter.group.id != null">
                  <v-flex xs12 sm6 class="px-1">
                    <div class="caption">Sub Group</div>
                    <multiselect
                      class="mb-3"
                      v-model="filter.subgroup"
                      :key="`sub_${filter.group.id}`"
                      :options="agentSubGroupOptions"
                      label="subgroupname"
                      selectLabel
                      selectedLabel
                      :allow-empty="false"
                      :searchable="false"
                      deselect-label
                      @input="onChangeSubGroup"
                      track-by="subgroupname"
                    ></multiselect>
                  </v-flex>
                </template>
              </v-layout>

              <date-range-picker v-model="selectedDate"></date-range-picker>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" depressed @click="onSearch" :loading="loading">
                {{
                $t('Search')
                }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <div class="mb-2">
      <v-chip dark color="blue" v-for="(item,k) in showFilter" :key="k">{{item}}</v-chip>
    </div>

    <div v-if="loading" class="py-5 text-xs-center">
      <v-progress-circular indeterminate color="primary "></v-progress-circular>
    </div>

    <div
      v-else
      class="pa-2"
      style="height: calc(100vh - 112px);  overflow-x: auto; overflow-y: visible"
    >
      <v-layout
        justify-start
        align-start
        fill-height
        row
        class="mb-0 ml-0"
        :style="{ width: groups.length * 310 + 'px' }"
      >
        <template v-for="group in groups">
          <funnel-line
            :value="group"
            :key="group.text + '_' + timestamp"
            :data="filterUsers"
            @onMoveToAnotherLine="onMoveToAnotherLine"
          ></funnel-line>
        </template>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import FunnelLine from './FunnelLine'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'
import XLSX from 'xlsx'

const DateRangePicker = () => import('./DateRangePicker')
export default {
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent',
    }),
    showFilter() {
      var result = []

      if (this.filter.group && this.filter.group.groupname != 'All') {
        result.push(`Group: ${this.filter.group.groupname}`)
      }
      if (this.filter.subgroup && this.filter.subgroup.subgroupname != 'All') {
        result.push(`Sub Group: ${this.filter.subgroup.subgroupname}`)
      }
      if (this.filter.admin && this.filter.admin.name != 'All') {
        result.push(`Name: ${this.filter.admin.name}`)
      }
      if (this.selectedDate.start) {
        result.push(
          `Start Date: ${moment(this.selectedDate.start).format('DD/MM/YYYY')} ${
            this.selectedDate.starttime ? this.selectedDate.starttime : ''
          }`
        )
      }
      if (this.selectedDate.end) {
        result.push(
          `End Date: ${moment(this.selectedDate.end).format('DD/MM/YYYY')} ${
            this.selectedDate.endtime ? this.selectedDate.endtime : ''
          }`
        )
      }
      return result
    },

    agentGroupOptions() {
      return this.loadingAgentGroup
        ? []
        : [
            {
              groupname: 'All',
              id: null,
            },
            ...this.agentGroup,
          ]
    },
    agentSubGroupOptions() {
      if (!this.filter.group) {
        return []
      }
      var subgroup = this.agentSubGroup.filter((el) => {
        return el.admingroupid == this.filter.group.id
      })
      return this.loadingAgentSubGroup
        ? []
        : [
            {
              subgroupname: 'All',
              id: null,
            },
            ...subgroup,
          ]
    },
  },
  components: {
    FunnelLine,
    datepicker,
    DateRangePicker,
    Multiselect,
  },
  data() {
    return {
      groups: [
        {
          text: 'Chat with bot',
          value: 'open',
        },
        {
          text: 'Pending',
          value: 'pending',
        },
        {
          text: 'Answered',
          value: 'answered',
        },
        {
          text: 'Closed',
          value: 'closed',
        },
        {
          text: 'Cancelled',
          value: 'cancelled',
        },
        {
          text: 'Cancelled Ticket by Customer',
          value: 'cancelled by customer',
        },
      ],
      users: [],
      loading: true,
      timestamp: moment().format('x'),
      selectedDate: {
        start: null,
        end: null,
        starttime: null,
        endtime: null,
      },
      showSearch: false,
      filter: {
        group: {
          groupname: 'All',
          id: null,
        },
      },
      filterUsers: [],
    }
  },
  async mounted() {
    this.loading = true
    try {
      var responseTicket = await this.getTicketsByStatus()
      if (responseTicket.data) {
        this.users = responseTicket.data
        this.filterUsers = await this.onfilterUsers()
        // this.agents = this.calculateTicket(responseTicket.data)
      }
    } catch (error) {
      console.error(error)
    }
    this.loading = false
  },
  methods: {
    exportData() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'funnel'

      var json = []
      json = this.filterUsers.map((el) => {
        return {
          Priority: el.priority ? el.priority : '-',
          Name: el.first_name ? el.first_name + ' ' + el.last_name : '-',
          'Latest Email': el.email ? el.email : '-',
          Channel: el.channel ? el.channel : '-',
          Subject: el.subject ? el.subject : '-',
          Details: el.details ? el.details : '-',
          Status: el.status ? el.status : '-',
          'Assign To': el.assignadminid ? el.assignadminid : '-',
          'Start time': el.starttime ? moment(el.starttime).format('DD/MM/YYYY HH:mm') : '-',
          'End Time': el.endtime ? moment(el.endtime).format('DD/MM/YYYY HH:mm') : '-',
          'Due Date': el.duedate ? el.duedate : '-',
          Tags: el.tags ? el.tags : '-',
        }
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    onfilterUsers() {
      if (this.$store.state.privilege) {
        switch (this.$store.state.privilege.view_ticket) {
          case 'all':
            return this.users
          case 'only_me':
            return this.users.filter((el) => {
              return el.assignadminid == this.$store.state.userid
            })
          case 'only_group':
            return this.users.filter((el) => {
              return el.assigngroupid == this.$store.state.admingroupid
            })
          case 'only_subgroup':
            return this.users.filter((el) => {
              return el.assignsubgroupid == this.$store.state.adminsubgroupid
            })
          default:
            return []
        }
      } else {
        return []
      }
    },
    formatFilter() {
      var data = {}

      if (this.filter.group && this.filter.group.id != null) {
        data.admingroupid = this.filter.group.id
      }

      if (this.filter.subgroup && this.filter.subgroup.id != null) {
        data.adminsubgroupid = this.filter.subgroup.id
      }

      if (this.selectedDate.start) {
        data.starttime = moment(this.selectedDate.start).format('YYYY-MM-DD')
        if (this.selectedDate.starttime) {
          data.starttime += ' ' + this.selectedDate.starttime
        } else {
          data.starttime += ' ' + '00:00'
        }
      }

      if (this.selectedDate.end) {
        data.endtime = moment(this.selectedDate.end).format('YYYY-MM-DD')
        if (this.selectedDate.endtime) {
          data.endtime += ' ' + this.selectedDate.endtime
        } else {
          data.endtime += ' ' + '23:59'
        }
      }
      return data
    },
    onChangeGroup(val) {
      if (val.id) {
        this.$set(this.filter, 'subgroup', { id: null, subgroupname: 'All' })
      } else {
        this.$set(this.filter, 'subgroup', null)
      }
    },
    onChangeSubGroup(val) {},
    async onSearch() {
      this.loading = true
      try {
        var filter = this.formatFilter()
        this.offset = 0
        var responseTicket = await this.getTicketsByStatus(filter)
        if (responseTicket.data) {
          this.users = responseTicket.data
          // this.agents = this.calculateTicket(responseTicket.data)
        }
      } catch (error) {
        console.log(error)
      }
      this.loading = false
      this.showSearch = false
    },
    onMoveToAnotherLine(payload) {
      var index = this.users.findIndex((el) => {
        return el.id == payload.id
      })
      if (index != -1) {
        this.$set(this.users, index, payload)
      }
      this.timestamp = moment().format('x')
    },
    calculateTicket(data) {
      var list = {}
      var agents = []
      data.map((el) => {
        if (list.hasOwnProperty(el.adminid)) {
          list[el.adminid].all += parseInt(el.amount)
          switch (el.status) {
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              break
            case 'canceled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break

            default:
              break
          }
        } else {
          list[el.adminid] = {
            adminid: el.adminid,
            name: el.name,
            all: parseInt(el.amount),
            pending: 0,
            closed: 0,
            cancelled: 0,
          }

          switch (el.status) {
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
              break

            default:
              break
          }
        }
      })

      for (const key in list) {
        if (list.hasOwnProperty(key)) {
          const element = list[key]
          agents.push(element)
        }
      }

      return agents
    },
    getTicketsByStatus(filter = []) {
      var data = {
        pageid: this.selectedBot.pageid,
        ...filter,
      }
      return new Promise((resolve, reject) => {
        api.getTicketsByStatus(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/Funnel.vue